import { useRef } from 'react';
import cx from 'classnames';

import useInView from 'Utilities/useInView';

import { useBreakpoint } from 'Components/misc/Breakpoints/Breakpoints';

import { Article, Aside, ContentLayout } from '../../common/ContentLayout/ContentLayout';

import { AcceptAndConfirmSale } from './AcceptAndConfirmSale/AcceptAndConfirmSale';
import { AcceptAndConfirmSaleSticky } from './AcceptAndConfirmSale/AcceptAndConfirmSaleSticky';
import { FAQs } from './FAQs/FAQs';
import { SellerConfirmationExperimentProps } from './SellerConfirmationExperiment.types';

import styles from './SellerConfirmationExperiment.scss';

export const SellerConfirmationExperiment = (props: SellerConfirmationExperimentProps) => {
  const { minWidth: { breakpointMobile } } = useBreakpoint();
  const $wrapper = useRef<HTMLDivElement>(null);
  const isSectionVisible = useInView($wrapper, {
    rootMargin: '-24px',
  });

  return <div className={cx(styles.wrapper, {
    [styles.belowReserve]: !!props.isBelowReserve,
  })}>
    <ContentLayout>
      <Article>
        <div ref={$wrapper} style={{
          border: '1px solid red',
          padding: 24,
        }}>
          <AcceptAndConfirmSale className={styles.primaryAccept} {...props} />
        </div>
        <FAQs belowReserve={!!props.isBelowReserve} />
      </Article>
      <Aside>
        <p>Seller Acceptance Experiment Aside</p>
      </Aside>
    </ContentLayout>
    <AcceptAndConfirmSaleSticky visible={
      !breakpointMobile || (!!$wrapper.current && !isSectionVisible)
    }>
      <AcceptAndConfirmSale {...props} />
    </AcceptAndConfirmSaleSticky>
  </div>;
};
